import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { PipelineProvider } from "./lib/pipeline";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserProfile from "./pages/UserProfile";
import Pipelines from "./pages/Pipelines";
import PipelineDetail from "./pages/PipelineDetail";
import Campaigns from "./pages/Campaigns";
import Agents from "./pages/Agents";
import Territories from "./pages/Territories";
import WhatsAppSimulator from "./pages/WhatsAppSimulator";
import WebCMS from "./pages/WebCMS";
import AILogs from "./pages/AILogs";
import Scheduler from "./pages/Scheduler";
import Settings from "./pages/Settings";
import FounderDashboard from "./pages/FounderDashboard";
import DynamicSequence from "./pages/DynamicSequence";
import AmbassadorDashboard from "./pages/AmbassadorDashboard";
import IntelligenceDashboard from "./pages/IntelligenceDashboard";
import Templates from "./pages/Templates";
import Manual from "./pages/Manual";
import Calendar from "./pages/Calendar";
import Reminders from "./pages/Reminders";
import PublicBooking from "./pages/PublicBooking";
import PublicScheduler from "./pages/PublicScheduler";
import HomeV2 from "./pages/web/HomeV2";
import AspirantesV2 from "./pages/web/AspirantesV2";
import LegacyCohort from "./pages/LegacyCohort";
import WhatsAppNumbers from "./pages/WhatsAppNumbers";
import LeadSources from "./pages/LeadSources";
import Inbox from "./pages/Inbox";
import TeamUsers from "./pages/TeamUsers";
import OdooTest from "./pages/OdooTest";
import SupervisorDashboard from "./pages/SupervisorDashboard";
import SupervisorDiagnoses from "./pages/SupervisorDiagnoses";
import SupervisorRecommendations from "./pages/SupervisorRecommendations";
import SupervisorVersions from "./pages/SupervisorVersions";
import HumanInbox from "./pages/HumanInbox";
import Escalations from "./pages/Escalations";
import SupervisorAudit from "./pages/SupervisorAudit";

const Private = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

// Panel admin bajo basename="/admin". Todos los enlaces absolutos internos
// (ej. to="/users") resuelven automáticamente bajo /admin, sin cambios.
function AdminApp() {
  return (
    <BrowserRouter basename="/admin">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Private><Layout /></Private>}>
          <Route index element={<Dashboard />} />
          <Route path="founder" element={<FounderDashboard />} />
          <Route path="founder/dynamics-sequence" element={<DynamicSequence />} />
          <Route path="ambassador" element={<AmbassadorDashboard />} />
          <Route path="intelligence" element={<IntelligenceDashboard />} />
          <Route path="templates" element={<Templates />} />
          <Route path="manual" element={<Manual />} />
          <Route path="users" element={<Users />} />
          <Route path="users/:userId" element={<UserProfile />} />
          <Route path="legacy" element={<LegacyCohort />} />
          <Route path="pipelines" element={<Pipelines />} />
          <Route path="pipelines/:pipelineId" element={<PipelineDetail />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="agents" element={<Agents />} />
          <Route path="territories" element={<Territories />} />
          <Route path="whatsapp" element={<WhatsAppSimulator />} />
          <Route path="ai-logs" element={<AILogs />} />
          <Route path="scheduler" element={<Scheduler />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="reminders" element={<Reminders />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/web" element={<WebCMS />} />
          <Route path="settings/whatsapp" element={<WhatsAppNumbers />} />
          <Route path="settings/sources" element={<LeadSources />} />
          <Route path="settings/team" element={<TeamUsers />} />
          <Route path="settings/odoo" element={<OdooTest />} />
          <Route path="supervisor" element={<SupervisorDashboard />} />
          <Route path="supervisor/diagnoses" element={<SupervisorDiagnoses />} />
          <Route path="supervisor/recommendations" element={<SupervisorRecommendations />} />
          <Route path="supervisor/versions" element={<SupervisorVersions />} />
          <Route path="supervisor/escalations" element={<Escalations />} />
          <Route path="supervisor/inbox" element={<HumanInbox />} />
          <Route path="supervisor/audit" element={<SupervisorAudit />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

// Web Pública HM V2 (sin auth) en la raíz del dominio.
function PublicApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeV2 />} />
        <Route path="/aspirantes" element={<AspirantesV2 />} />
        <Route path="/book/:token" element={<PublicBooking />} />
        <Route path="/agendar" element={<PublicScheduler />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  const path = window.location.pathname;
  const isAdmin = path === "/admin" || path.startsWith("/admin/");
  return (
    <AuthProvider>
      <PipelineProvider>
        <Toaster position="top-right" richColors />
        {isAdmin ? <AdminApp /> : <PublicApp />}
      </PipelineProvider>
    </AuthProvider>
  );
}

export default App;
